const MAX_PERIOD_MS = 31 * 24 * 60 * 60 * 1000;

export function formatDate(value) {
  return value ? new Date(value).toLocaleString() : "-";
}

export function formatDuration(value) {
  if (value === null || value === undefined) return "-";
  return value < 1000 ? `${Math.round(value)} ms` : `${(value / 1000).toFixed(1)} s`;
}

export function formatRate(value) {
  return `${((value || 0) * 100).toFixed(1)}%`;
}

export function isValidPeriod(from, to) {
  return !Number.isNaN(from.getTime())
    && !Number.isNaN(to.getTime())
    && from < to
    && to - from <= MAX_PERIOD_MS;
}

export function toDateTimeInputValue(date) {
  const offset = date.getTimezoneOffset() * 60 * 1000;
  return new Date(date.getTime() - offset).toISOString().slice(0, 16);
}
